import { ChainType } from '@ankr.com/chains-list';
import { useEffect, useState } from 'react';

import { EndpointGroup } from 'modules/endpoints/types';

import { defaultChainsSelectorsValue } from '../context';

interface UseChainCallProtocolProps {
  chainType: ChainType;
  group: EndpointGroup;
}

export const useChainCallProtocol = ({
  chainType,
  group,
}: UseChainCallProtocolProps) => {
  const [chainCallProtocol, setChainCallProtocol] = useState(
    defaultChainsSelectorsValue.chainCallProtocol,
  );

  useEffect(() => {
    setChainCallProtocol(defaultChainsSelectorsValue.chainCallProtocol);
  }, [chainType]);

  useEffect(() => {
    const mappedFeatures = group.chains
      .filter(chain => chain.paths?.length)
      .flatMap(chain => chain.features);

    const grpcOnly =
      mappedFeatures.length > 0 &&
      mappedFeatures.every(feature => feature === 'grpc');

    setChainCallProtocol(
      grpcOnly ? 'grpc' : defaultChainsSelectorsValue.chainCallProtocol,
    );
  }, [group]);

  return { chainCallProtocol, setChainCallProtocol };
};
